var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{class:{ footer: true, absolute: _vm.absolute }},[_c('p',{staticClass:"copyright"},[_vm._v("© "+_vm._s(_vm.theYear)+" "+_vm._s(_vm.siteName)+" "),(_vm.version)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.version)}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }